import React, { useState, useRef } from 'react';
import { BRAND } from './statuses';

interface Props {
  tags: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
}

export const TagEditor: React.FC<Props> = ({ tags, onChange, disabled }) => {
  const [adding, setAdding] = useState(false);
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const add = () => {
    const v = value.trim().toLowerCase();
    if (!v) {
      setAdding(false);
      setValue('');
      return;
    }
    if (tags.includes(v)) {
      setValue('');
      setAdding(false);
      return;
    }
    onChange([...tags, v].sort());
    setValue('');
    setAdding(false);
  };

  const remove = (t: string) => {
    onChange(tags.filter((x) => x !== t));
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
      {tags.map((t) => (
        <span
          key={t}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '3px 8px 3px 10px',
            borderRadius: 100,
            background: 'var(--surface-mint)',
            color: BRAND.green,
            fontSize: 11,
            fontWeight: 600,
          }}
        >
          #{t}
          {!disabled && (
            <button
              onClick={() => remove(t)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: BRAND.green,
                fontSize: 14,
                lineHeight: 1,
                padding: 0,
                opacity: 0.6,
              }}
              title={`Remove ${t}`}
            >
              ×
            </button>
          )}
        </span>
      ))}

      {adding && !disabled ? (
        <input
          ref={inputRef}
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={add}
          onKeyDown={(e) => {
            if (e.key === 'Enter') add();
            if (e.key === 'Escape') {
              setValue('');
              setAdding(false);
            }
          }}
          placeholder="tag..."
          style={{
            padding: '3px 8px',
            border: `1px solid ${BRAND.border}`,
            borderRadius: 100,
            fontSize: 11,
            width: 90,
            outline: 'none',
            background: BRAND.surface,
          }}
        />
      ) : (
        !disabled && (
          <button
            onClick={() => setAdding(true)}
            style={{
              padding: '3px 10px',
              borderRadius: 100,
              border: `1px dashed ${BRAND.border}`,
              background: 'transparent',
              color: BRAND.textMuted,
              fontSize: 11,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            + tag
          </button>
        )
      )}
    </div>
  );
};
